export default __webpack_public_path__ + "static/media/01.4573ae31.jpg";